export default __webpack_public_path__ + "static/media/odciskpo.29e581aa.jpeg";